module.exports = __webpack_public_path__ + "img/green-star.d4c5bb58.svg";